import(/* webpackMode: "eager" */ "D:\\GIT Repos\\assistiv\\app\\(portal)\\layout.tsx")